import React from 'react';
import IconButton from 'material-ui/IconButton';
import UserSearchField from 'components/pure/utils/form/UserSearchField';
import PersonAddIcon from 'components/pure/utils/icon/PersonAddIcon';
import get from 'lodash/get';
import TriggerPermission from 'records/TriggerPermission';
import intersection from 'lodash/intersection';
import TeamSelectField from './TeamSelectField';
import DepartmentSelectField from './DepartmentSelectField';
import SelectField from 'components/pure/utils/form/SelectField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import './RulePermissionCreator.styl';
import AuthStore from 'stores/AuthStore';
import moment from 'moment';

export default class RulePermissionCreator extends React.PureComponent {
  constructor(props) {
    super(props);
    this.addPermission = this.addPermission.bind(this);
    const {sessionUser} = this.props;
    const accountPermission = new TriggerPermission({
      accountId: sessionUser.accountId,
    });
    const shareTypes = [
      {
        label: 'Everyone',
        value: {
          onSelect: () => this.setState({permission: accountPermission}),
        },
        permissions: ['can_share_triggers_globally'],
        hideIf: () =>
          this.props.rulePermissions
            .filter(perm => perm.active)
            .some(perm => perm.isSameTarget(accountPermission)),
      },
      {
        label: 'Department',
        value: {
          selector: props => (
            <DepartmentSelectField
              value={get(this, 'state.permission.departmentId')}
              departments={this.props.departmentProfiles.filter(
                dept => !props.activePermissions.some(perm => perm.departmentId === dept.id)
              )}
              onChange={departmentId =>
                this.setState({
                  permission: new TriggerPermission({departmentId}),
                })
              }
            />
          ),
        },
        permissions: ['can_share_triggers_with_departments'],
      },
      {
        label: 'Team',
        value: {
          selector: props => (
            <TeamSelectField
              value={get(this, 'state.permission.teamId')}
              teams={this.props.teams.filter(
                dept => !props.activePermissions.some(perm => perm.teamId === dept.id)
              )}
              onChange={teamId =>
                this.setState({
                  permission: new TriggerPermission({teamId}),
                })
              }
            />
          ),
        },
        permissions: ['can_share_triggers_with_teams'],
      },
      {
        label: 'User',
        value: {
          selector: props => (
            <UserSearchField
              excludeUserIds={props.activePermissions.map(perm => perm.userId).filter(id => !!id)}
              value={get(this, 'state.permission.userId')}
              onChange={userId => this.setState({permission: new TriggerPermission({userId})})}
              sessionUser={AuthStore.getState().user}
            />
          ),
        },
        permissions: ['view_all_account', 'view_team', 'view_all_department'],
      },
    ].filter(option => intersection(option.permissions, sessionUser.permissions).length > 0);
    this.state = {shareTypes};
  }

  addPermission() {
    this.props.onUpdate(
      this.props.rulePermissions.push(this.state.permission.set('uiCreationTime', moment()))
    );
    this.setState({selection: null, permission: null});
  }

  render() {
    const {selection, permission} = this.state;
    const ShareSelector = selection && selection.selector;
    const shareTypes = this.state.shareTypes.filter(option => !option.hideIf || !option.hideIf());
    return (
      <FieldContainer label="Share with:" labelType="div" className="rule-permission-creator">
        <SelectField
          value={selection}
          placeholder="Choose a share type"
          options={shareTypes}
          hideResetButton={true}
          tether={true}
          onChange={selection => {
            this.setState({selection, permission: null});
            selection.onSelect && selection.onSelect();
          }}
        />
        {ShareSelector && (
          <ShareSelector
            activePermissions={this.props.rulePermissions.filter(perm => perm.active)}
          />
        )}
        {permission && (
          <IconButton onClick={this.addPermission} className="add-share-button">
            <PersonAddIcon />
          </IconButton>
        )}
      </FieldContainer>
    );
  }
}
